/**
 * Event Switcher
 *
 * @returns {{init: init}}
 */
const EventSwitch = (() => {
	const DOM = {};

	const cacheDOM = () => {
		DOM.upcomingTab = document.querySelector('.upcoming-tab');
		DOM.pastTab = document.querySelector('.past-tab');
		DOM.upcomingDiv = document.querySelector('.upcoming');
		DOM.pastDiv = document.querySelector('.past');
	};

	const switchTab = (event) => {
		event.preventDefault();
		const isUpcoming = event.target === DOM.upcomingTab;

		// Toggle active-tab class on the tabs
		DOM.upcomingTab.classList.toggle('active-tab', isUpcoming);
		DOM.pastTab.classList.toggle('active-tab', !isUpcoming);

		// Toggle active class on the content divs
		DOM.upcomingDiv.classList.toggle('active', isUpcoming);
		DOM.pastDiv.classList.toggle('active', !isUpcoming);
	};

	const addEventListeners = () => {
		DOM.upcomingTab.addEventListener('click', switchTab);
		DOM.pastTab.addEventListener('click', switchTab);
	};

	const init = () => {
		cacheDOM();
		addEventListeners();
	};

	return {
		init,
	};
})();

export default EventSwitch;
